import PhotoSwipeLightbox from 'https://www.unpkg.com/photoswipe@5.2.7/dist/photoswipe-lightbox.esm.min.js';
import PhotoSwipe from 'https://www.unpkg.com/photoswipe@5.2.7/dist/photoswipe.esm.min.js';

export class ProductSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const gallery = this.els?.gallery?.selector || this.externalEls?.gallery?.selector

    if (!this.els?.link?.exists || !gallery) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: true,
      showAnimationDuration: 500,
      gallery: gallery,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: true,
      close: false,
      counter: false,
      closeOnVerticalDrag: false,
      paddingBottom: 20,
      paddingTop: 20,
      paddingLeft: 20,
      paddingRight: 20,
      maxHeightRatio: 0.9,
      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addPreviousButton()
      this.addNextButton()
      this.addCloseButton()
      this.addCaption()
      this.addDots()
    })

    this.photoSwipeInstance.on('openingAnimationStart', () => {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('pswp-open');
    });

    this.photoSwipeInstance.on('close', () => {
      document.body.style.overflow = '';
      document.body.classList.remove('pswp-open');
    });

    this.photoSwipeInstance.on('firstUpdate', () => {
      setTimeout(() => {
        this.setupWheelScrolling();
        this.addScrollIndicators();
        this.adjustCaptionGap();
      }, 300);
    });

    this.photoSwipeInstance.on('slideComplete', () => {
      setTimeout(() => {
        const currSlide = this.photoSwipeInstance.pswp.currSlide;
        if (currSlide && this.captionContainer) {
          this.adjustPhotoSwipeHeight(this.photoSwipeInstance.pswp, this.captionContainer);
          this.adjustCaptionGap();
        }
      }, 100);
    });
  }

  adjustCaptionGap () {
    const pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    try {
      const imgWrap = pswpElement.querySelector('.pswp__zoom-wrap');
      if (imgWrap) {
        imgWrap.style.marginBottom = '-20px';
      }

      const images = pswpElement.querySelectorAll('.pswp__img');
      if (images.length > 0) {
        images.forEach(img => {
          img.style.marginBottom = '0';
        });
      }

      if (this.captionContainer) {
        this.captionContainer.style.marginTop = '-30px';
      }

      const scrollIndicator = pswpElement.querySelector('.pswp-scroll-indicator');
      if (scrollIndicator) {
        scrollIndicator.style.top = '-20px';
      }

      const captionIndicator = pswpElement.querySelector('.pswp-caption-indicator');
      if (captionIndicator) {
        captionIndicator.style.top = '-25px';
      }
    } catch (error) {
      console.error('Error adjusting caption gap:', error);
    }
  }

  addScrollIndicators () {
    const pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    const indicatorDiv = document.createElement('div');
    indicatorDiv.className = 'pswp-caption-indicator';

    const arrow = document.createElement('div');
    arrow.className = 'pswp-caption-indicator-arrow';

    indicatorDiv.appendChild(arrow);
    pswpElement.appendChild(indicatorDiv);

    const scrollText = document.createElement('div');
    scrollText.className = 'pswp-scroll-indicator';
    scrollText.textContent = 'Scroll for more';

    pswpElement.appendChild(scrollText);
  }

  setupWheelScrolling () {
    const pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    pswpElement.addEventListener('wheel', (e) => {
      if (e.ctrlKey) {
        return;
      }

      e.stopPropagation();
      e.preventDefault();

      pswpElement.scrollBy({
        top: e.deltaY,
        behavior: 'smooth'
      });
    }, { passive: false });

    const scrollWrap = pswpElement.querySelector('.pswp__scroll-wrap');
    if (scrollWrap) {
      scrollWrap.addEventListener('wheel', (e) => {
        if (e.ctrlKey) return;

        e.stopPropagation();
        e.preventDefault();

        pswpElement.scrollBy({
          top: e.deltaY,
          behavior: 'smooth'
        });
      }, { passive: false });
    }

    pswpElement.addEventListener('scroll', () => {
      const scrollIndicator = document.querySelector('.pswp-scroll-indicator');
      const indicatorArrow = document.querySelector('.pswp-caption-indicator-arrow');

      if (scrollIndicator) {
        scrollIndicator.style.opacity = '0';
      }

      if (indicatorArrow) {
        indicatorArrow.style.opacity = '0';
      }
    }, { once: true });
  }

  updateCaptionInPhotoSwipe (index) {
    if (!this.captionContainer || !this.els?.link?.elements[index]) return;

    try {
      const captionText = this.els.link.elements[index].getAttribute('data-caption') || '';
      const customiserLink = this.els.link.elements[index].getAttribute('data-customise-link');

      const hasCaptionContent = captionText || customiserLink;

      this.captionContainer.style.display = hasCaptionContent ? 'block' : 'none';

      const scrollIndicator = document.querySelector('.pswp-scroll-indicator');
      const captionIndicator = document.querySelector('.pswp-caption-indicator');

      if (scrollIndicator) {
        scrollIndicator.style.display = hasCaptionContent ? 'block' : 'none';
      }

      if (captionIndicator) {
        captionIndicator.style.display = hasCaptionContent ? 'block' : 'none';
      }

      let captionHTML = '';
      if (captionText) {
        captionHTML += `<div class="pswp-caption-text">${captionText}</div>`;
      }

      if (customiserLink) {
        captionHTML += `<a href="${customiserLink}" class="pswp-customizer-link primary-button w-button sec-InspirationCarousel_Submit">${window.theme.strings.customiseProductCTA}</a>`;
      }

      this.captionContainer.innerHTML = captionHTML;

      if (this.photoSwipeInstance && this.photoSwipeInstance.pswp) {
        this.adjustPhotoSwipeHeight(this.photoSwipeInstance.pswp, this.captionContainer);
      }

      this.updateSlideLayout(hasCaptionContent);

    } catch (error) {
      console.error('Error updating caption:', error);
    }
  }

  updateSlideLayout (hasCaptionContent) {
    try {
      const pswpElement = document.querySelector('.pswp');
      if (!pswpElement) return;

      const zoomWraps = pswpElement.querySelectorAll('.pswp__zoom-wrap');
      const slideContainers = pswpElement.querySelectorAll('.pswp__item');

      if (!hasCaptionContent) {
        zoomWraps.forEach(wrap => {
          wrap.style.height = '100%';
          wrap.style.marginBottom = '0';
        });

        slideContainers.forEach(container => {
          container.style.height = '100%';
        });

        if (this.photoSwipeInstance && this.photoSwipeInstance.pswp) {
          setTimeout(() => {
            this.photoSwipeInstance.pswp.updateSize(true);
          }, 50);
        }
      }
    } catch (error) {
      console.error('Error updating slide layout:', error);
    }
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
        this.updateCaptionInPhotoSwipe(this.photoSwipeInstance.pswp.currIndex)
      },
    })
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
        this.updateCaptionInPhotoSwipe(this.photoSwipeInstance.pswp.currIndex)
      },
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        const upArrow = document.createElement('button')
        upArrow.type = 'button'
        upArrow.className = 'pswp-Action_DotArrow pswp-Action_DotArrow-up'
        upArrow.innerHTML = this.blackArrowSvg
        upArrow.onclick = () => {
          const activeIndex = pswp.currIndex
          if (activeIndex > 0) {
            pswp.goTo(activeIndex - 1)
            this.updateCaptionInPhotoSwipe(activeIndex - 1)
          }
        }
        element.appendChild(upArrow)

        const dotContainer = document.createElement('div')
        dotContainer.className = 'pswp-Action_DotsContainer'
        element.appendChild(dotContainer)

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.onclick = event => {
            const index = dotEls.indexOf(event.target)
            pswp.goTo(index)
            this.updateCaptionInPhotoSwipe(index)
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          dotContainer.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        const downArrow = document.createElement('button')
        downArrow.type = 'button'
        downArrow.className = 'pswp-Action_DotArrow pswp-Action_DotArrow-down'
        downArrow.innerHTML = this.blackArrowSvg
        downArrow.onclick = () => {
          const activeIndex = pswp.currIndex
          if (activeIndex < pswp.getNumItems() - 1) {
            pswp.goTo(activeIndex + 1)
            this.updateCaptionInPhotoSwipe(activeIndex + 1)
          }
        }
        element.appendChild(downArrow)

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          const currentDot = dotEls[pswp.currIndex]
          currentDot.setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
          currentDot.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })

          this.updateCaptionInPhotoSwipe(pswp.currIndex)

          setTimeout(() => this.adjustCaptionGap(), 100);
        })
      },
    })
  }

  addCaption () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 10,
      isButton: false,
      appendTo: 'wrapper',
      html: () => {
        return '<div class="pswp-caption-container"></div>';
      },
      onInit: (el, pswp) => {
        this.captionContainer = el;

        el.classList.add('pswp-caption-container');
        el.style.marginTop = '-30px';
        el.style.display = 'none';

        const pswpElement = document.querySelector('.pswp');
        if (pswpElement) {
          pswpElement.style.overflowY = 'auto';
        }

        setTimeout(() => {
          this.updateCaptionInPhotoSwipe(pswp.currIndex);
          this.adjustPhotoSwipeHeight(pswp, el);
          this.adjustCaptionGap();
        }, 300);

        pswp.on('change', () => {
          this.updateCaptionInPhotoSwipe(pswp.currIndex);
          this.adjustPhotoSwipeHeight(pswp, el);
        });

        window.addEventListener('resize', () => {
          this.adjustPhotoSwipeHeight(pswp, el);
          this.adjustCaptionGap();
        });
      },
    });
  }

  adjustPhotoSwipeHeight (pswp, captionEl) {
    if (!pswp || !captionEl) return;

    try {
      if (captionEl.style.display === 'none') {
        this.maximizeImageSize(pswp);
        return;
      }

      const captionHeight = captionEl.scrollHeight || 0;

      if (captionHeight === 0) {
        this.maximizeImageSize(pswp);
        return;
      }

      const adjustedCaptionHeight = Math.max(captionHeight - 30, 0);

      const pswpElement = document.querySelector('.pswp');
      if (!pswpElement) return;

      const contentContainer = pswpElement.querySelector('.pswp__scroll-wrap');
      if (!contentContainer) return;

      contentContainer.style.minHeight = `calc(100% + ${adjustedCaptionHeight}px)`;
      contentContainer.style.paddingBottom = '20px';

      pswpElement.style.overflowY = 'auto';
      pswpElement.style.overflowX = 'hidden';

      setTimeout(() => {
        pswp.updateSize(true);
      }, 50);

    } catch (error) {
      console.error('Error adjusting PhotoSwipe height:', error);
    }
  }

  maximizeImageSize (pswp) {
    try {
      const pswpElement = document.querySelector('.pswp');
      if (!pswpElement) return;

      const contentContainer = pswpElement.querySelector('.pswp__scroll-wrap');
      if (contentContainer) {
        contentContainer.style.minHeight = '100%';
        contentContainer.style.paddingBottom = '0';
      }

      const images = pswpElement.querySelectorAll('.pswp__img');
      images.forEach(img => {
        img.style.maxHeight = '100vh';
      });

      setTimeout(() => {
        pswp.updateSize(true);
      }, 50);

    } catch (error) {
      console.error('Error maximizing image size:', error);
    }
  }

  get blackArrowSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" fill="none" viewBox="0 0 12 8"><g stroke="#432741" stroke-linecap="round" stroke-linejoin="round" clip-path="url(#a)"><path d="M.375 1.041C2.25 1.117 6 2.456 6 7.2M11.625 1.041C9.75 1.117 6 2.456 6 7.2"></path></g><defs><clipPath id="a"><path fill="#fff" d="M12 0v8H0V0z"></path></clipPath></defs></svg>`;
  }

  get arrowSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="none" viewBox="0 0 38 38"><g><path fill="#432741" fill-rule="evenodd" d="M35.455 9.5a4.172 4.172 0 0 1-1.041 5.37 4.172 4.172 0 0 1 0 8.26 4.172 4.172 0 0 1-4.13 7.154a4.172 4.172 0 0 1-7.154 4.13a4.172 4.172 0 0 1-8.26 0a4.172 4.172 0 0 1-7.154-4.13 4.172 4.172 0 0 1-4.13-7.154a4.172 4.172 0 0 1 0-8.26a4.172 4.172 0 0 1 4.13-7.154a4.172 4.172 0 0 1 7.154-4.13 4.172 4.172 0 0 1 8.26 0 4.172 4.172 0 0 1 7.154 4.13 4.172 4.172 0 0 1 5.17 1.784Z" clip-rule="evenodd"/><g stroke="#fff" stroke-linecap="round" stroke-linejoin="round" clip-path="url(#b)"><path d="M17.041 25.4c.076-2 1.414-6 6.159-6M17.041 13.4c.076 2 1.414 6 6.159 6"/></g></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h38v38H0z"/></clipPath><clipPath id="b"><path fill="#fff" d="M16 13h8v12.8h-8z"/></clipPath></defs></svg>`
  }

  get closeSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" fill-rule="evenodd" d="M15.789 16.498 1.646 2.355l.708-.707 14.142 14.143-.707.707Z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M16.496 2.354 2.354 16.496l-.708-.707L15.79 1.647l.707.707Z" clip-rule="evenodd"/></svg>`
  }
}

if (!customElements.get('product-gallery-swipe')) {
  customElements.define('product-gallery-swipe', ProductSwipe)
}
